import { Api } from 'utils';

class PackageService {
  // Catálogo de paquetes disponibles para el usuario (filtra por su level_id y solo activos).
  static get = async (params?: any) => Api.createResponse('app/packages/', params);
  // Cobra, emite factura SIGECE y crea el paquete del usuario.
  static pay = async (params?: any) => Api.createResponse('app/packages/pay', params);
  // Paquetes ya comprados por el usuario (no vencidos), con su saldo.
  static getUserPackages = async (params?: any) => Api.createResponse('app/packages/mine', params);

  static admin = {
    get: async (params?: any) => Api.createResponse('admin/packages/', params),
    create: async (params?: any) => Api.createResponse('admin/packages/create', params),
    update: async (params?: any) => Api.createResponse('admin/packages/update', params),
    delete: async (params?: any) => Api.createResponse('admin/packages/delete', params),
    getLevels: async (params?: any) => Api.createResponse('admin/packages/levels', params),
    getServices: async (params?: any) => Api.createResponse('admin/packages/services', params),
  };
}

export default PackageService;
